<template>
  <VView class="contest-instructions" back-button-to="/menu" :header="$t('contestInstructions.header')">
    <VText><small>za chwilę rozpoczniesz grę, w której sprawdzisz się jako operator dźwigu. Twoim zadaniem będzie <span>umieszczenie ładunku na ciężarówce.</span></small></VText>
    <VText><small>Za pomocą <span>przycisków znajdujących się pod dźwigiem</span> postaraj się umieścić ładunek w jak najkrótszym czasie.</small></VText>
    <VText><small>W zadaniu będzie przeszkadzał Ci <span>silny wiatr,</span> na który musisz zwrócić uwagę podczas umieszczania ładunku na ciężarówce.</small></VText>

    <VMedia class="contest-instructions__picture"><img src="@/assets/instructions.png" /></VMedia>

    <VButtonGroup>
      <transition name="bounceUp" appear>
        <VButton to="/contest/game" special>Zaczynajmy!</VButton>
      </transition>
    </VButtonGroup>
  </VView>
</template>

<script>
import VView from '@/components/VView.vue';
import VMedia from '@/components/VMedia.vue';
import VText from '@/components/VText.vue';
import VButton from '@/components/VButton.vue';
import VButtonGroup from '@/components/VButtonGroup.vue';

export default {
  name: 'ContestInstructions',
  components: {
    VView,
    VMedia,
    VText,
    VButton,
    VButtonGroup,
  },
};
</script>

<style lang="scss" scoped>
.contest-instructions {
  &__picture {
    margin: 100px auto 50px;
  }
}
</style>
